<template>
  <form-wrapper :validator="$v.value">
    <!-- <div class="">Address Details</div> -->
    <section class="content-body">
      <!-- <div class="tab-title-2">Address Details</div> -->
      <b-row>
        <b-col cols="6">
          <AddressInput
            ref="AddressInput"
            :data="address"
            :actionName="actionName"
            @saveAddress="save"
            @clearAddress="clear"
            :isFormDisabled="false"
          />
        </b-col>
        <b-col cols="6">
          <AddressList
            ref="AddressList"
            @editAddress="editAddress"
            :data="value"
          />
        </b-col>
      </b-row>

      <!-- <div>
        <div class="panel-message-error">
          <p class="semibold red">Errors</p>
          <ul class="error-list">
            <li>
              ghghgh
            </li>
          </ul>
        </div>
      </div> -->
    </section>
    <!--  <form-summary/>-->
  </form-wrapper>
</template>

<script>
import BaseDatePicker from "@/components/base/BaseDatePicker";
import AddressInput from "@/components/sections/Address/Input";
import AddressList from "@/components/sections/Address/List";

import { AddressModel } from "@/models/AddressModel";

import { mapState, mapGetters } from "vuex";

import { required } from "vuelidate/lib/validators";
import { formatDate } from "@/utils/datehelper";
import lodash from "lodash";

export default {
  components: {
    AddressInput,
    AddressList,
    BaseDatePicker,
  },
  computed: {
    // ...mapGetters("customer", [
    //   "getAddresses"
    // ]),
  },
  props: {
    value: {
      type: Object,
      default: {},
    },
    metaData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // data:
      address: Object.assign({}, AddressModel),
      index: -1,
    };
  },
  methods: {
    editAddress(index) {
      this.index = index;
      const address = this.value[index];
      this.address = lodash.cloneDeep(address);
      this.address = Object.assign({}, address);
      this.actionName = "Save";
    },
    save(address) {
      if (this.index == -1) {
        this.value.push(address);
      } else {
        let value = lodash.cloneDeep(this.value);
        value[this.index] = address;
        this.value = value;
      }
      this.$emit("input", this.value);

      this.address = Object.assign({}, AddressModel);
      this.$v.$reset();
    },
    clearValidations() {
      if (this.$refs.AddressInput) {
        this.$refs.AddressInput.clearValidations();
      }
    },
    clear() {
      this.address = Object.assign({}, AddressModel);
    },
    isValid() {
      this.$v.$touch(); // it will validate all fields

      let status = false;

      if (status) {
        // invalid, becomes true when a validations return false
        return true;
      } else {
        return false;
      }
    },
    DateFormat(dob) {
      return formatDate(dob);
    },
  },
  validations: {
    value: {},
  },
};
</script>
